import { Body } from '@shipt/design-system-typography'

export const Prop65Warning = () => (
  <Body size="sm" variant="secondary" as="div">
    California Proposition 65 <strong>WARNING</strong> for exposure to Bisphenol A (BPA) from canned
    and bottled foods and beverages: Many food and beverage cans have linings containing bisphenol A
    (BPA), a chemical known to the State of California to cause harm to the female reproductive
    system, or birth defects, or cancer. Jar lids and bottle caps may also contain BPA. You can be
    exposed to BPA when you consume foods or beverages packaged in these containers. For more
    information go to:{' '}
    <a href="https://www.p65warnings.ca.gov/bpa" rel="noopener noreferrer" target="_blank">
      www.p65warnings.ca.gov/BPA
    </a>
    <br />
    <br />
    <strong>WARNING:</strong> Drinking distilled spirits, beer, coolers, wine and other alcoholic
    beverages may increase cancer risk, and, during pregnancy, can cause birth defects. For more
    information, go to{' '}
    <a href="https://www.p65warnings.ca.gov/alcohol" rel="noopener noreferrer" target="_blank">
      www.p65warnings.ca.gov/alcohol
    </a>
  </Body>
)
